module.exports = __webpack_public_path__ + "img/gou.341fb144.png";